
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './component/ErrorBoundary';
import './index.css';
import './i18n';

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
} else {
  console.error('Root element not found');
}
